export default {"src":"/_next/static/media/icon-testfreaks.c433e0de.svg","height":14,"width":18,"blurWidth":0,"blurHeight":0};